import { render, staticRenderFns } from "./UploadPreviewPayRoll.vue?vue&type=template&id=40a4f36a&scoped=true"
import script from "./UploadPreviewPayRoll.vue?vue&type=script&lang=js"
export * from "./UploadPreviewPayRoll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a4f36a",
  null
  
)

export default component.exports